import { Injectable } from '@angular/core';
import { Basket as NBasket } from '@df/basket/basket.interfaces';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { Events } from '@df/core/service/event';
import { Prefs } from '@df/session/prefs';
import { Basket } from '@df/session/api/basket/basket';
import { Gtm } from '@df/module-gtm/gtm.namespace';
import { GtmService } from '@df/module-gtm/gtm.service';

@Injectable({
    providedIn: 'root'
})
export class GtmCheckoutPlugin {
    /**
     * Class dependnecies
     */
    constructor(
        private gtm: GtmService,
        private prefs: Prefs,
        private events: Events,
        private basket: Basket
    ) {
        this.trackCheckout();
    }

    /**
     * Set up tracking
     */
    private trackCheckout() {
        this.events.on(NBasket.EVENTS.view).subscribe(() => this.onBasketInit());
        this.events.on(Checkout.EVENTS.Init).subscribe(() => this.onCheckoutInit());
        this.events.on(Checkout.EVENTS.StepChange).subscribe(event => this.onStepChange(event));
        this.events.on(Checkout.EVENTS.StepValidityChange).subscribe(event => this.onStepValidityChange(event));
        this.events.on(Checkout.EVENTS.SuccessTracking).subscribe(() => this.onCheckoutSuccess());
    }

    /**
     * Notify about checkout start
     */
    private onBasketInit() {
        const basketData = this.basket.data;
        this.gtm.push({
            event: 'basket.view',
            'basket-items': this.gtm.getBasketProductsData(),
            'basket-general': {
                currencyCode: this.prefs.getCurrencyCode(),
                value: this.basket.subtotal
            },
            coupon: basketData.coupon ? (Array.isArray(basketData.coupon) ? basketData.coupon.join(', ') : basketData.coupon) : undefined
        } as any);
    }
    /**
     * Notify about checkout start
     */
    private onCheckoutInit() {
        this.gtm.push({ ...this.gtm.getBeginCheckoutEventData(), event: 'checkout.start' });
    }

    /**
     * Notify about going to step
     */
    private onStepChange(event: Checkout.IStepChangeEventData) {
        this.gtm.push(<Gtm.IEvent>{
            event: `checkout.step_view.${event.stepName}`
        });
    }

    /**
     * Notify about going to step
     */
    private onStepValidityChange(event: Checkout.IStepValidityChangeData) {
        if (event.step.valid) {
            this.gtm.push(<Gtm.IEvent>{
                event: `checkout.step_valid.${event.step.name}`
            });
        }
    }

    /**
     * Notify about going to step
     */
    private onCheckoutSuccess() {
        this.gtm.push({ event: 'checkout.success' });
    }
}
